import React, { useState } from "react";
import { ParseErrors } from "../../utils/parse-errors";
import { toast } from "react-toastify";
import axiosInstance from "../../utils/axios-instance";
import UseAuth from "../../utils/use-auth";
import Button from "../button/Button";
import SuretyModel from "../../models/surety-model";

const UserSettingsTab = () => {
  const { UpdateLoginData, HandleUserLogOut, user } = UseAuth();
  const [values, setValues] = useState<Record<string, any>>({});
  const [profilePicture, setProfilePicture] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isDelete, setIsDelete] = useState(false);

  const HandleUpdateMe = async () => {
    if (validate()) {
      setLoading(true);
      try {
        const res = await axiosInstance.patch("/user/update/me", { ...values });
        toast.success("User Updated Successfully");
        UpdateLoginData({ isLoggedIn: true, data: res.data.data });
        setLoading(false);
      } catch (error) {
        console.log(error);
        toast.error(ParseErrors(error));
        setLoading(false);
      }
    }
  };

  const HandleValues = (e) => {
    setValues((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleProfilePictureChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setProfilePicture(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const validate = () => {
    if (!values.cpassword) {
      toast.error("Please enter current password to update");
      return false;
    } else {
      return true;
    }
  };

  const toggleDeletePopup = () => {
    setIsDelete((prev) => !prev);
  };

  const HandleDeleteMe = async () => {
    setLoading(true);
    try {
      const res = await axiosInstance.delete("/auth/delete");
      toast.success(res.data.message);
      HandleUserLogOut();
      toggleDeletePopup();
      setLoading(false);
    } catch (error) {
      console.log(error);
      toast.error(ParseErrors(error));
      setLoading(false);
    }
  };

  const inputClass = "w-full px-4 py-3 rounded-xl border border-gray-200 bg-white text-[14.5px] placeholder-gray-400";
  const labelClass = "block text-[13px] font-medium text-lightBlack mb-1.5";

  return (
    <div className="w-[92%] md:w-[60%] lg:w-[50%] mx-auto py-12">
      <div className="bg-white border border-gray-100 rounded-3xl p-8 lg:p-10 shadow-soft">
        <div className="flex flex-col items-center mb-8">
          <div className="relative w-24 h-24 group">
            {profilePicture ? (
              <img
                src={profilePicture}
                alt="Profile"
                className="w-24 h-24 rounded-full object-cover ring-4 ring-blue/10"
              />
            ) : (
              <div className="w-24 h-24 rounded-full bg-blue/10 flex items-center justify-center ring-4 ring-blue/5">
                <span className="text-3xl font-display font-semibold text-blue uppercase">
                  {user?.name?.slice(0, 2)}
                </span>
              </div>
            )}
            <input
              type="file"
              className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
              onChange={handleProfilePictureChange}
            />
            <div className="absolute -bottom-1 -right-1 h-7 w-7 rounded-full bg-blue text-white flex items-center justify-center text-xs shadow-soft pointer-events-none">
              ✎
            </div>
          </div>
          <h2 className="font-display text-2xl font-semibold tracking-tight text-lightBlack mt-4">
            Account Settings
          </h2>
          <p className="text-sm text-gray-500 mt-1">Manage your profile and security</p>
        </div>

        <div className="space-y-5">
          <div>
            <label className={labelClass}>User Name</label>
            <input
              type="text"
              name="name"
              className={inputClass}
              defaultValue={user?.name}
              onChange={HandleValues}
            />
          </div>
          <div>
            <label className={labelClass}>Email</label>
            <input
              type="email"
              name="email"
              className={inputClass}
              defaultValue={user?.email}
              onChange={HandleValues}
            />
          </div>
          <div>
            <label className={labelClass}>Current Password</label>
            <input
              type="password"
              name="cpassword"
              placeholder="Enter your current password"
              className={inputClass}
              value={values?.cpassword || ""}
              onChange={HandleValues}
            />
          </div>
          <div>
            <label className={labelClass}>New Password</label>
            <input
              type="password"
              name="password"
              placeholder="Choose a new password"
              className={inputClass}
              value={values?.password || ""}
              onChange={HandleValues}
            />
          </div>

          <div className="pt-2">
            <Button
              children={"Save Changes"}
              disabled={loading}
              isLoading={loading}
              onClick={HandleUpdateMe}
            />
          </div>

          <div className="pt-6 mt-6 border-t border-gray-100">
            <h3 className="text-sm font-medium text-lightBlack mb-1">Danger zone</h3>
            <p className="text-xs text-gray-500 mb-3">Permanently delete your account and all of its data.</p>
            <Button
              children={"Delete Account"}
              className="!bg-red-50 !text-red-600 !border !border-red-100 hover:!bg-red-100"
              variant="secondary"
              disabled={loading}
              isLoading={loading}
              onClick={toggleDeletePopup}
            />
          </div>
        </div>
      </div>

      {isDelete ? (
        <SuretyModel
          toggleModel={toggleDeletePopup}
          onClick={HandleDeleteMe}
          isLoading={loading}
        />
      ) : null}
    </div>
  );
};

export default UserSettingsTab;
